import ConfigurablePane from './_configurable-pane.js'
import ConfigurablePosition from './_configurable-position.js'
import ConfigurableTransition from './_configurable-transition.js'
import ConfigurableMargin from './_configurable-margin.js'

export default {
  name: 'SelectedIndicator',
  values: {
    style: {
      base: {
        width: undefined,
        height: undefined,
        transform: undefined,
        left: '8px',
        right: '8px',
        bottom: '0px',
        transitionProperty: 'all',
        transitionDuration: '0.2s',
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurablePosition,
          },
          {
            configSet: ConfigurableTransition,
          },
          {
            configSet: ConfigurableMargin,
          },
        ],
      },
      unselected: {
        width: undefined,
        height: undefined,
        transform: undefined,
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurablePosition,
          },
        ],
      },
    },
  },
  meta: {
    extendable: false,
  },
}
